import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";

// for staging
// const firebaseConfig = {
//   apiKey: "AIzaSyCfRxbRrq0_oCxJ8mjxN8T6weAz1chp9OI",
//   authDomain: "bfc-staging.firebaseapp.com",
//   projectId: "bfc-staging",
//   storageBucket: "bfc-staging.firebasestorage.app",
//   messagingSenderId: "359876582506",
//   appId: "1:359876582506:web:fb130cdddcc00e6a0bbe13",
//   measurementId: "G-GJ0H5FGSF3"
// };

// for production
const firebaseConfig = {
  apiKey: "AIzaSyBTBSuyaKc1RcEDdDxD66uSNFlomItWbkk",
  authDomain: "bisleri-320a2.firebaseapp.com",
  projectId: "bisleri-320a2",
  storageBucket: "bisleri-320a2.appspot.com",
  messagingSenderId: "207369623210",
  appId: "1:207369623210:web:0f3750042c2293d17862d3",
  measurementId: "G-8ZL56W5EWL"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({ timestampsInSnapshots: true });
//firebase.analytics();
const storage = firebase.storage();
export { storage, firebase };